module.exports = __webpack_public_path__ + "static/media/grass.a5fff7b5.png";